import { Divider, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { NextArrowIcon } from "src/assets/Icons";
import { explode } from "src/utility";
import { useSSRContext } from "../../context/SSRContext";

export default function FlightSelection() {
  const { t } = useTranslation();
  const { flightOptions, cursor, handleChange } = useSSRContext();

  const currentIndex = flightOptions.findIndex((flight) => flight!.value === cursor.flightId);
  const currentFlight = flightOptions[currentIndex];
  const hasMultipleFlights = flightOptions.length > 1;

  if (!currentFlight) return null;

  const items = flightOptions.map((flight) => {
    const { origin, destination } = explode(flight!, {});
    return {
      key: flight!.value,
      label: (
        <div className="flex items-center gap-2">
          {origin.code}
          <NextArrowIcon className="h-3 w-3" />
          {destination.code}
        </div>
      ),
    };
  });

  return (
    <div className="flex w-full flex-col gap-4">
      {hasMultipleFlights && (
        <Tabs
          items={items}
          activeKey={cursor.flightId}
          onChange={(value) => handleChange("flightId", value)()}
          className="w-full!"
          more={{
            visible: false,
          }}
          classNames={{
            item: "uppercase! font-medium! text-sm! px-2!",
            header: "mb-0!",
          }}
        />
      )}
      <div className="flex w-full items-end justify-between gap-2">
        <div className="flex flex-col">
          <div className="text-font-minimal text-sm">
            {currentFlight.segmentIndex === 0 ? t("Flights.search.departure") : t("Flights.search.return")}
          </div>
          <div className="text-xl uppercase md:text-2xl">
            {currentFlight.origin.code} {t("Flights.search.to")} {currentFlight.destination.code}
          </div>
        </div>
        {hasMultipleFlights && (
          <div className="text-font-minimal text-xs">
            {t("Flights.details.ssr.flightOfTotal", { current: currentIndex + 1, total: flightOptions.length })}
          </div>
        )}
      </div>
      <Divider className="m-0!" />
    </div>
  );
}
